import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home'
import Location from './views/Location'
import Catalog from './views/Catalog'
import Order from './views/Order'
import OrderDetail from './views/OrderDetail'
import SendOrder from './views/SendOrder'
import OrderStatus from './views/OrderStatus'
import Help from './views/Help'
import PaymentFormData from './components/Payment/PaymentFormData'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/location',
      name: 'location',
      component: Location,
    },
    {
      path: '/catalog',
      name: 'catalog',
      component: Catalog,
    },
    {
      path: '/order/:key',
      name: 'order-detail',
      component: OrderDetail,
    },
    {
      path: '/order',
      name: 'order',
      component: Order,
    },
    {
      path: '/send-order',
      name: 'send-order',
      component: SendOrder,
    },
    {
      path: '/order/status/:userId/:orderId',
      name: 'order-status',
      component: OrderStatus,
    },
    {
      path: '/order/payment/:merchant/:signature/:version',
      name: 'payment-form',
      component: PaymentFormData,
    },
    {
      path: '/help',
      name: 'help-page',
      component: Help,
    },
  ],
  mode: 'history',
})
